import { render, staticRenderFns } from "./UpdateQuotesDialog.vue?vue&type=template&id=e544a2ee&scoped=true"
import script from "./UpdateQuotesDialog.vue?vue&type=script&lang=js"
export * from "./UpdateQuotesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e544a2ee",
  null
  
)

export default component.exports